import { LucideIcon } from "lucide-react";
import {
  Card,
  CardContent,
} from "@/projects/Civi_Circle_Admin/components/ui/card";
import { cn } from "@/projects/Civi_Circle_Admin/lib/utils";

interface StatCardProps {
  title: string;
  value: string | number;
  change?: string;
  changeType?: "increase" | "decrease";
  icon: LucideIcon;
  iconColor?: string;
}

export function StatCard({
  title,
  value,
  change,
  changeType,
  icon: Icon,
  iconColor = "text-primary",
}: StatCardProps) {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="mt-2 text-3xl font-bold">{value}</p>
            {change && (
              <p
                className={cn(
                  "mt-2 flex items-center gap-1 text-sm",
                  changeType === "increase"
                    ? "text-success"
                    : "text-destructive"
                )}
              >
                <span>
                  {changeType === "increase" ? "â†‘" : "â†“"} {change}
                </span>
                <span className="text-muted-foreground">vs last month</span>
              </p>
            )}
          </div>
          <div
            className={cn(
              "flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10",
              iconColor
            )}
          >
            <Icon className="h-6 w-6" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
